var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.13942 2.96V0H0.661621V2.96C0.661621 4.0534 1.29367 4.9976 2.20932 5.4423C2.41617 5.54275 2.55052 5.75055 2.55052 5.9821V6.01795C2.55052 6.2495 2.41617 6.45725 2.20932 6.55775C1.29367 7.00245 0.661621 7.9466 0.661621 9.04005V12H6.13942V9.04C6.13942 7.9466 5.50737 7.0024 4.59172 6.5577C4.38487 6.45725 4.25052 6.24945 4.25052 6.0179V5.98205C4.25052 5.7505 4.38487 5.54275 4.59172 5.44225C5.50737 4.9976 6.13942 4.05345 6.13942 2.96Z",
    fill: "#FFEACF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.73905 9.19055C5.6562 9.19055 5.58905 9.1234 5.58905 9.04055C5.58905 8.19835 5.1031 7.41825 4.35105 7.053C4.27655 7.0168 4.24545 6.92705 4.28165 6.85255C4.3179 6.77805 4.4076 6.747 4.4821 6.78315C5.3368 7.1982 5.88905 8.08425 5.88905 9.0405C5.88905 9.1234 5.8219 9.19055 5.73905 9.19055Z",
    fill: "#FCF9DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.60932 6.5577C3.81617 6.4572 3.95052 6.24945 3.95052 6.0179V5.98205C3.95052 5.7505 3.81617 5.54275 3.60932 5.44225C2.69367 4.99755 2.06162 4.0534 2.06162 2.95995V0H0.661621V2.96C0.661621 4.0534 1.29367 4.9976 2.20932 5.4423C2.41617 5.5428 2.55052 5.75055 2.55052 5.9821V6.01795C2.55052 6.2495 2.41617 6.45725 2.20932 6.55775C1.29367 7.00245 0.661621 7.9466 0.661621 9.04005V12H2.06162V9.04C2.06162 7.9466 2.69367 7.0024 3.60932 6.5577Z",
    fill: "#FFD59A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.37592 3.98291C1.74842 4.72591 2.51237 5.23686 3.39287 5.23686H3.40802C4.28852 5.23686 5.05247 4.72591 5.42497 3.98291H1.37592Z",
    fill: "#F9BB32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.66671 11.2221V10.8494C5.66671 9.59324 4.65331 8.57129 3.40761 8.57129H3.39246C2.14681 8.57129 1.13336 9.59324 1.13336 10.8494V11.2221H5.66671Z",
    fill: "#F9BB32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.60081 4.76172H3.20081V8.76172H3.60081V4.76172Z",
    fill: "#F9BB32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.06111 9.04005C2.06111 9.0301 2.06156 9.02025 2.06166 9.01025C1.49946 9.42505 1.13336 10.0949 1.13336 10.8496V11.2223H2.06116L2.06111 9.04005Z",
    fill: "#DB9C2E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.19971 6.80218C3.32546 6.71103 3.45926 6.63048 3.59971 6.56163V5.43733C3.45926 5.36848 3.32546 5.28798 3.19971 5.19678V6.80218Z",
    fill: "#DB9C2E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.25207 5.23216C2.80887 4.92631 2.45977 4.49226 2.25717 3.98291H1.37592C1.72842 4.68601 2.43147 5.18101 3.25207 5.23216Z",
    fill: "#DB9C2E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.51562 1.05444H0.284622C0.127472 1.05444 0.00012207 0.927036 0.00012207 0.769936V0.291336C0.00012207 0.134186 0.127522 0.00683594 0.284622 0.00683594H6.51562C6.67277 0.00683594 6.80012 0.134236 6.80012 0.291336V0.769936C6.80012 0.927036 6.67272 1.05444 6.51562 1.05444Z",
    fill: "#BF6C0D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M0.284622 10.9438H6.51562C6.67277 10.9438 6.80012 11.0712 6.80012 11.2283V11.7069C6.80012 11.8641 6.67272 11.9914 6.51562 11.9914H0.284622C0.127472 11.9914 0.00012207 11.864 0.00012207 11.7069V11.2283C0.00012207 11.0712 0.127522 10.9438 0.284622 10.9438Z",
    fill: "#BF6C0D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M2.75627 2.20566C3.0048 2.20566 3.20627 2.00419 3.20627 1.75566C3.20627 1.50714 3.0048 1.30566 2.75627 1.30566C2.50775 1.30566 2.30627 1.50714 2.30627 1.75566C2.30627 2.00419 2.50775 2.20566 2.75627 2.20566Z",
    fill: "#FFD59A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.75627 10.8004C3.0048 10.8004 3.20627 10.5989 3.20627 10.3504C3.20627 10.1019 3.0048 9.90039 2.75627 9.90039C2.50775 9.90039 2.30627 10.1019 2.30627 10.3504C2.30627 10.5989 2.50775 10.8004 2.75627 10.8004Z",
    fill: "#DB9C2E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1.40012 0.769936V0.291386C1.40012 0.134186 1.52752 0.00683594 1.68462 0.00683594H0.284622C0.127472 0.00683594 0.00012207 0.134236 0.00012207 0.291386V0.769936C0.00012207 0.927086 0.127522 1.05444 0.284622 1.05444H1.68462C1.52752 1.05444 1.40012 0.927036 1.40012 0.769936Z",
    fill: "#A56021"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M1.40012 11.7069V11.2283C1.40012 11.0712 1.52752 10.9438 1.68462 10.9438H0.284622C0.127472 10.9438 0.00012207 11.0712 0.00012207 11.2283V11.7069C0.00012207 11.8641 0.127522 11.9914 0.284622 11.9914H1.68462C1.52752 11.9914 1.40012 11.8641 1.40012 11.7069Z",
    fill: "#A56021"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.27576edceae363edbbd02fe5fa65ff75.svg";
export { ForwardRef as ReactComponent };